import { registerPlugin } from '@capacitor/core';

const AudioPlugin = registerPlugin('AudioRecordPlugin');

export default AudioPlugin;
